
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { vuex } from "@/store";
import rest from '@/rest';
// components
// import { mavonEditor } from 'mavon-editor';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import MarkdownAiChatDlg from '../ContentCreator/MarkdownAiChatDlg.vue';
import SimpleMessageBox from './SimpleMessageBox.vue';
// interfaces
import { CustomizationVm } from '@/interfaces/CustomizationVm';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { ExBundle } from '@/interfaces/UnsubscribedTopic';
import { ExBundleVM } from '@/interfaces/ExBundleAssignmentGroupVM';

// Global registration
Vue.use(mavonEditor);

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    // mavonEditor,
    MarkdownAiChatDlg,
    SimpleMessageBox
  },
})
export default class MarkdownEditor extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;
  // @Prop({ default: '' }) readonly initialContent!: string;
  @PropSync("content") syncedContent!: string;
  @Prop({ default: ''}) filePath!: string;
  @Prop({ default: false }) saveToFile!: boolean;

  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedBundle!: ExBundleVM
  @customization.Getter customizationSettings!: CustomizationVm;

  showAiChatDialog = false;
  showConfirmationDialog = false;
  markdownContent = '';
  isBusyOnPdfCreation = false;
  isBusyOnSaveMarkdown = false;

  // Standard-Toolbar-Optionen
  toolbars = {
    bold: true,
    italic: true,
    header: true,
    underline: true,
    strikethrough: true,
    mark: true,
    superscript: true,
    subscript: true,
    quote: true,
    ol: true,
    ul: true,
    link: true,
    imagelink: true,
    code: true,
    table: true,
    fullscreen: true,
    readmodel: true,
    help: true,
    undo: true,
    redo: true,
    trash: true,
    navigation: true,
    alignleft: true,
    aligncenter: true,
    alignright: true,
    preview: true,
  };

  created() {
    this.markdownContent = this.syncedContent;
  }
  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      this.markdownContent = this.syncedContent;
    } else {
      // Dialog closing
    }
  }

  // @Watch('content')
  // onInitialContentChange(newValue: string) {
  //   this.markdownContent = newValue;
  // }

  onContentChange(value: string) {
    // console.log("onContentChange", value);
    // this.$emit('input', value);
    // this.$emit('change', value);
  }

  onClose() {
    if (this.syncedContent != this.markdownContent) {
      this.showConfirmationDialog = true;
      return;
    }

    this.syncedShowDialog = false;
  }

  async onCloseEditor(save: boolean) {
    if (save) {
      await this.saveMarkdown();
    }

    this.syncedShowDialog = false;
  }

  async saveMarkdown() {
    this.syncedContent = this.markdownContent;
    if (!this.saveToFile) return;

    this.isBusyOnSaveMarkdown = true;
    // console.log("saveMarkdown", this.syncedContent, this.markdownContent);

    let params = <ParamDictionary>{dictionary: {}};
    params.dictionary!["Content"] = this.markdownContent;
    params.dictionary!["BundleId"] = this.selectedBundle?.id.toString() ?? "";
    params.dictionary!["MarkdownPath"] = this.filePath ?? "";

    await rest.url("contentManager/saveMarkdownFile")
    .post(params)
    .then((response) => {
      // console.log("markdownAiChatDlg response: ", response);
      if (!response) return;
      this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

      let fileName = this.$globalHelper.extractFileName(response);
      vuex.ux.SB_SUCCESS({
        message: `Die Datei '${fileName}' wurde im Medien Pool der Schulung gespeichert.`,
        timeout: 5000
      });
    })
    .finally(() => {
      this.isBusyOnSaveMarkdown = false;
    });
  }

  async onConvertToPdf() {
    let params = <ParamDictionary>{dictionary: {}};
    params.dictionary!["Content"] = this.markdownContent;
    params.dictionary!["ExerciseId"] = this.selectedExercise?.id.toString() ?? "";
    params.dictionary!["MarkdownPath"] = this.filePath;

    this.isBusyOnPdfCreation = true;

    await rest.url("contentManager/markdownToPdfConverter")
    .post(params)
    .then((response) => {
      // console.log("markdownAiChatDlg response: ", response);
      if (!response) return;
      this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

      let fileName = this.$globalHelper.extractFileName(response);
      vuex.ux.SB_SUCCESS({
        message: `Das PDF mit dem Namen '${fileName}' wurde im Medien Pool der Schulung gespeichert.`,
        timeout: 5000
      });
    })
    .finally(() => {
      this.isBusyOnPdfCreation = false;
    });

  }
}
